import type { EventEmitter } from '@widgets/shared/types'
import { broadcastEventEmitterService } from '@widgets/shared/services/broadcastEventEmitterService'

export class MessengerBroadcastEventEmitterService implements EventEmitter {
  protected broadcastEventEmitterService = broadcastEventEmitterService

  protected uniqueCode: string

  protected domain: string

  public init(params: { uniqueCode: string; domain: string }) {
    this.uniqueCode = params.uniqueCode
    this.domain = params.domain
  }

  public on<T>(eventCode: string, callback: (payload: T) => void, options?: { receiveOwnMessages?: boolean }): string {
    return this.broadcastEventEmitterService.on(this.getEventCode(eventCode), callback, options)
  }

  public remove(id: string) {
    this.broadcastEventEmitterService.remove(id)
  }

  public emit<T>(eventCode: string, payload?: T) {
    this.broadcastEventEmitterService.emit(this.getEventCode(eventCode), payload)
  }

  protected getEventCode(eventCode: string) {
    return `${this.domain}-${this.uniqueCode}-${eventCode}`
  }
}

export const messengerBroadcastEventEmitterService = new MessengerBroadcastEventEmitterService()
